import { gql } from "@apollo/client";

export const GET_WAREHOUSES = gql`
	query GetWarehouses {
		warehouses {
			id
			name
			city
			alias1C
		}
	}
`;

export const UPDATE_WAREHOUSE = gql`
	mutation UpdateWarehouse($input: UpdateWarehouseInput!) {
		updateWarehouse(input: $input) {
			id
		}
	}
`;

export const DELETE_WAREHOUSE = gql`
	mutation DeleteWarehouse($id: String!) {
		deleteWarehouse(id: $id)
	}
`;
